<template>
    <div class="inline-flex">
        <div v-if="!isTouchDevice" class="btn btn-sm btn-yellow" @click="openModal">
            Tools
            <i class="fas fa-caret-down ml-1"></i>
        </div>

        <modal id="modalTools" @close="showModal=false" ref="modalRef" v-if="showModal">
            <template #header>
                <span>
                    Tools
                </span>
                <div class="snap-to-closest">
                    <div class="p-1">
                        <label for="snap-to-closest-input">
                            <input @change="snap" :value="true" v-model="snapAnnotationsToPrices" id="snap-to-closest-input" type="checkbox" name="snap-to-closest">
                            Snap to Closest Price
                        </label>
                    </div>
                </div>
            </template>

            <template #body>
                <tabs class="tabs-modal" :options="{ useUrlFragment: false, defaultTabHash: tabHash }">
                    <tab name="Drawings">
                        <div class="tools-wrapper">
                            <div class="flex flex-wrap">
                                <div class="w-1/2 p-0">
                                    <ul class="tool-items" @click="applyTool">
                                        <li data-value="Line">
                                            <i class="bc-glyph-trendline"></i>
                                            Trendline
                                        </li>
                                        <li data-value="HorizontalLine">
                                            <i class="bc-glyph-line-vertical"></i>
                                            Horizontal Line
                                        </li>
                                        <li data-value="VerticalLine">
                                            <i class="bc-glyph-line-horizontal"></i>
                                            Vertical Line
                                        </li>
                                        <li data-value="FiftyPercentLine">
                                            <i class="bc-glyph-middle-line"></i>
                                            50% Line
                                        </li>
                                        <li data-value="TrendChannel">
                                            <i class="bc-glyph-channel"></i>
                                            Trend Channel
                                        </li>
                                        <li data-value="FibonacciArcs">
                                            <i class="bc-glyph-arc"></i>
                                            Fibonacci Arcs
                                        </li>
                                        <li data-value="SpeedResistanceArcs">
                                            <i class="bc-glyph-arc"></i>
                                            Resistance Arcs
                                        </li>
                                        <li data-value="Ellipse">
                                            <i class="bc-glyph-ellipse"></i>
                                            Ellipse
                                        </li>
                                    </ul>
                                </div>
                                <div class="w-1/2 p-0">
                                    <ul class="tool-items" @click="applyTool">
                                        <li data-value="Text">
                                            <i class="bc-glyph-text-caret"></i>
                                            Text
                                        </li>
                                        <li data-value="FibonacciRetracement">
                                            <i class="bc-glyph-retracement"></i>
                                            Fib Retracement
                                        </li>
                                        <li data-value="AndrewsPitchfork">
                                            <i class="bc-glyph-pitchfork"></i>
                                            Pitchfork
                                        </li>
                                        <li data-value="FibonacciFan">
                                            <i class="bc-glyph-fan"></i>
                                            Fibonacci Fan
                                        </li>
                                        <li data-value="SpeedResistanceFan">
                                            <i class="bc-glyph-fan"></i>
                                            Resistance Fan
                                        </li>
                                        <li data-value="GannFan">
                                            <i class="bc-glyph-fan"></i>
                                            Gann Fan
                                        </li>
                                        <li data-value="FibonacciTimeZones">
                                            <i class="bc-glyph-timezone"></i>
                                            Time Zone
                                        </li>
                                        <li data-value="Rectangle">
                                            <i class="bc-glyph-rectangle"></i>
                                            Rectangle
                                        </li>
                                    </ul>

                                </div>
                            </div>
                        </div>
                    </tab>
                    <tab name="Symbols">
                        <div class="tools-wrapper">
                            <div class="flex flex-wrap">
                                <div class="w-1/2 p-0">
                                    <ul class="tool-items" @click="applyTool">
                                        <li data-value="SymbolArrowUp">
                                            <i class="bc-glyph-arrow-up"></i>
                                            Arrow Up
                                        </li>
                                        <li data-value="SymbolArrowDown">
                                            <i class="bc-glyph-arrow-down"></i>
                                            Arrow Down
                                        </li>
                                        <li data-value="SymbolArrowRight">
                                            <i class="bc-glyph-arrow-right"></i>
                                            Arrow Right
                                        </li>
                                        <li data-value="SymbolArrowLeft">
                                            <i class="bc-glyph-arrow-left"></i>
                                            Arrow Left
                                        </li>
                                        <li data-value="SymbolArcUp">
                                            <i class="bc-glyph-arc-up"></i>
                                            Arc Up
                                        </li>
                                        <li data-value="SymbolArcDown">
                                            <i class="bc-glyph-arc-down"></i>
                                            Arc Down
                                        </li>
                                        <li data-value="SymbolFishHook">
                                            <i class="bc-glyph-fish-hook"></i>
                                            Fish Hook
                                        </li>
                                    </ul>
                                </div>
                                <div class="w-1/2 p-0">
                                    <ul class="tool-items" @click="applyTool">
                                        <li data-value="SymbolThumbsUp">
                                            <i class="bc-glyph-thumbs-o-up"></i>
                                            Thumb Up
                                        </li>
                                        <li data-value="SymbolThumbsDown">
                                            <i class="bc-glyph-thumbs-o-down"></i>
                                            Thumb Down
                                        </li>
                                        <li data-value="SymbolOne">
                                            <i class="bc-glyph-circle-1"></i>
                                            Number 1
                                        </li>
                                        <li data-value="SymbolTwo">
                                            <i class="bc-glyph-circle-2"></i>
                                            Number 2
                                        </li>
                                        <li data-value="SymbolThree">
                                            <i class="bc-glyph-circle-3"></i>
                                            Number 3
                                        </li>
                                        <li data-value="SymbolQuestion">
                                            <i class="bc-glyph-circle-question"></i>
                                            Question?
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </tab>
                    <tab name="Calculators">
                        <div class="tools-wrapper">
                            <div class="flex flex-wrap">
                                <div class="w-1/2 p-0">
                                    <ul class="tool-items" @click="applyTool">
                                        <li data-value="LongPosition">
                                            <svg height="14px" width="16px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" class="align-middle mr-2">
                                                <rect y="0.6" width="18" height="1.4"/>
                                                <rect width="2.9" height="2.7"/>
                                                <rect y="8.3" width="18" height="1.4"/>
                                                <rect y="16" width="18" height="1.4"/>
                                                <rect x="3.3" y="8.1" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 17.4895 -0.5105)" width="11.3" height="0.8"/>
                                                <polyline points="6.4,4.9 9,2.4 11.6,4.9 "/>
                                                <polyline points="11.6,13.1 9,15.6 6.4,13.1 "/>
                                                <rect x="15.1" y="15.3" width="2.9" height="2.7"/>
                                                <rect y="7.6" width="2.9" height="2.7"/>
                                                <rect x="15.1" y="7.6" width="2.9" height="2.7"/>
                                            </svg>
                                            Long Position
                                        </li>
                                        <li data-value="ShortPosition">
                                            <svg height="14px" width="16px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" class="align-middle mr-2">
                                                <rect y="0.6" width="18" height="1.4"/>
                                                <rect width="2.9" height="2.7"/>
                                                <rect y="8.3" width="18" height="1.4"/>
                                                <rect y="16" width="18" height="1.4"/>
                                                <rect x="3.3" y="8.1" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 17.4895 -0.5105)" width="11.3" height="0.8"/>
                                                <polyline points="6.4,4.9 9,2.4 11.6,4.9 "/>
                                                <polyline points="11.6,13.1 9,15.6 6.4,13.1 "/>
                                                <rect x="15.1" y="15.3" width="2.9" height="2.7"/>
                                                <rect y="7.6" width="2.9" height="2.7"/>
                                                <rect x="15.1" y="7.6" width="2.9" height="2.7"/>
                                            </svg>
                                            Short Position
                                        </li>
                                    </ul>
                                </div>
                                <div class="w-1/2 p-0">
                                    <ul class="tool-items" @click="applyTool">
                                        <li data-value="CalculateProfitLoss">
                                            <i class="bc-glyph-percent"></i>
                                            Profit/Loss
                                        </li>
                                        <li data-value="CalculateRiskReward">
                                            <i class="bc-glyph-calculator"></i>
                                            Reward/Risk
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </tab>
                </tabs>
            </template>

            <template #footer>
                <div class="flex justify-center">
                    <div class="btn btn-sm btn-yellow-ghost inline-flex mx-1" @click="showModal=false">Cancel</div>
                </div>
            </template>
        </modal>

        <modal-tool
            v-if="toolModal"
            @add="addModalTool"
            @pick="pickPoint"
            @close="toolModal=false"
            :symbol="symbol"
            :type="modalToolType"
            :default-traits="modalTraits"
        ></modal-tool>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import ModalTool from './ModalTool'

const props = defineProps({
    initialSnap: Boolean,
    initialHide: Boolean,
    symbol: String
});

const emit = defineEmits(['snap', 'add-tool']);

const showModal = ref(false);
const toolModal = ref(false);
const modalTraits = ref({});
const modalToolType = ref(null);
const snapAnnotationsToPrices = ref(props.initialSnap || false);
const isTouchDevice = ref(detectTouch());
const tabHash = ref(null);

function openModal(pTab) {
    if (pTab) {
        tabHash.value = pTab;
        console.log(tabHash.value);
    }
    showModal.value = true;
}

function isModalTool(pTool) {
    return ['CalculateProfitLoss', 'CalculateRiskReward', 'FiftyPercentLine'].includes(pTool);
}

function pickPoint() {
    emit('add-tool', 'PickPoint');
}

function addModalTool(pTool, pTraits, pValue) {
    emit('add-tool', pTool, pTraits, pValue);
}

function applyTool(pEvent) {
    // Check if the clicked element is an <i> tag, and if so, use its parent.
    // Otherwise, use the clicked element itself.
    const element = pEvent.target.tagName === 'I' ? pEvent.target.parentNode : pEvent.target;

    // Get the 'value' attribute from the element
    const value = element.getAttribute('data-value');

    // if (!value || hideTools.value) {
    if (!value) {
        return;
    }

    showModal.value = false;

    let traits;
    try {
        traits = JSON.parse(window.localStorage.getItem(value));
    } catch (e) {
        traits = null;
    }

    if (isModalTool(value)) {
        toolModal.value = true;

        if (value === 'CalculateProfitLoss') {
            modalToolType.value = 'profit';
        } else if (value === 'CalculateRiskReward') {
            modalToolType.value = 'risk';
        } else if (value === 'FiftyPercentLine') {
            modalToolType.value = 'fiftyPercent'
        }

        if (modalToolType.value) {
            modalTraits.value = traits;
            pickPoint();
        }
    } else {
        if (!traits) {
            traits = getDefaultTraits(value);
        }

        emit('add-tool', value, traits);
    }
}

function getDefaultTraits(pToolName) {
    if (['Ellipse', 'Rectangle'].includes(pToolName)) {
        return {
            fill: { color: 'rgba(255, 0, 0, 0.3)' },
        };
    } else if (['Line', 'HorizontalLine', 'VerticalLine'].includes(pToolName)) {
        return {
            line: { width: 2 }
        };
    }
}

function snap() {
    emit('snap', snapAnnotationsToPrices.value);
}

function detectTouch() {
    // Testing better detection of a mouse
    return !window.matchMedia(`(any-pointer:fine)`).matches
    // return 'ontouchstart' in window || (navigator.maxTouchPoints > 0);
}

function setMouseDevice(pEvent) {
    console.log('Mouse detected');
    isTouchDevice.value = false;
    document.removeEventListener('mousemove', setMouseDevice);
}

onMounted(() => {
    // document.addEventListener('mousemove', setMouseDevice);
});
defineExpose({
    openModal
});
</script>

<style lang="scss">
#modalTools {
    .modal-container {
        width: 24rem;
        @screen xs {
            width: 100%;
        }
    }

    .snap-to-closest {
        label {
            @apply text-xs;
        }
    }

    .tabs-component {
        .tools-wrapper {
            @apply m-0 p-0 my-4 text-sm;
        }
        .tool-items {
            @apply list-none p-0;

            li {
                @apply text-sm cursor-pointer my-2 flex items-center;
                i {
                    // vertical-align: sub;
                    @apply text-lg text-black mr-2;
                }
                &:hover {
                    @apply text-blue-500;
                    i {
                        @apply text-blue-500;
                    }
                }
            }
        }
    }
}
</style>
